import { render } from "./PublisherMaterialRequestsAdminPage.vue?vue&type=template&id=0d51e93b&scoped=true"
import script from "./PublisherMaterialRequestsAdminPage.vue?vue&type=script&lang=js"
export * from "./PublisherMaterialRequestsAdminPage.vue?vue&type=script&lang=js"

import "./PublisherMaterialRequestsAdminPage.vue?vue&type=style&index=0&id=0d51e93b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d51e93b"]])

export default __exports__